import AXIOS from "@/axios";
import { APIResponse } from "@/types";
import {
  AssignmentFormData,
  AssignmentModel,
  AssignmentQuery,
  CourseAssignmentDetail,
  DownloadAssignmentQuery,
} from "@/types/assignment.model";
import { removeEmptyProps } from "@/utils/constants";
import { buildAssignmentRecordApiParams } from "@/utils/assignmentRecordParams";
import moment from "moment";

function withAssignmentRecordParams(
  query: AssignmentQuery | DownloadAssignmentQuery
): Record<string, unknown> {
  const { recordType, gradeId, classId, ...rest } = query;

  return removeEmptyProps({
    ...rest,
    ...buildAssignmentRecordApiParams({ recordType, gradeId, classId }),
  });
}

export const getAllAssignmentsService = async (query: AssignmentQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<AssignmentModel[]>>("/asgmt/api/v1/list", {
    params: withAssignmentRecordParams(query),
  });
};

export const getAssignmentService = async (id: string) => {
  return AXIOS.get<APIResponse<AssignmentFormData>>(`/asgmt/api/v1/view/${id}`);
};

export const createAssignmentService = async (payload: AssignmentFormData) => {
  return AXIOS.post<APIResponse<AssignmentFormData>>(
    `/asgmt/api/v1/add`,
    payload
  );
};

export const updateAssignmentService = async (
  id: string,
  payload: AssignmentModel
) => {
  return AXIOS.patch<APIResponse<AssignmentModel>>(
    `/asgmt/api/v1/update/${id}`,
    payload
  );
};

export const deleteAssignmentService = async (id: string) => {
  return AXIOS.delete<APIResponse<AssignmentModel>>(
    `/asgmt/api/v1/delete/${id}`
  );
};

export const downloadAssignmentService = async (
  type: "pdf" | "xl" | "csv",
  params: DownloadAssignmentQuery
) => {
  if (params.fromDate && params.toDate) {
    params.fromDate = moment(new Date(params.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    params.toDate = moment(new Date(params.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<{ message: string }>(`/asgmt/api/v1/dwnld/${type}`, {
    params: withAssignmentRecordParams(params),
    responseType: "blob",
  });
};

export const getAssignmentByCourseService = async (query: AssignmentQuery) => {
  if (query.fromDate && query.toDate) {
    query.fromDate = moment(new Date(query.fromDate).toISOString()).format(
      "DD-MM-YYYY"
    );
    query.toDate = moment(new Date(query.toDate).toISOString()).format(
      "DD-MM-YYYY"
    );
  }

  return AXIOS.get<APIResponse<CourseAssignmentDetail[]>>(
    `/asgmt/api/v1/detail/list`,
    {
      params: withAssignmentRecordParams(query),
    }
  );
};
